import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/utils/cn";

interface MonthNavProps {
  label: string;
  onPrev: () => void;
  onNext: () => void;
  onLabelClick?: () => void;
  /** Optional "This Month" button */
  showThisMonth?: boolean;
  onThisMonth?: () => void;
  className?: string;
}

/**
 * Reusable month navigation toolbar segment:
 *   [This Month]  ‹  Jun 2026  ›
 *
 * Used by both GRC Dashboard and Draft Calendar.
 */
export function MonthNav({
  label,
  onPrev,
  onNext,
  onLabelClick,
  showThisMonth,
  onThisMonth,
  className
}: MonthNavProps) {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      {showThisMonth && (
        <button
          type="button"
          onClick={onThisMonth}
          className="rounded border border-slate-300 px-3 py-1 text-sm hover:bg-slate-100"
        >
          This Month
        </button>
      )}
      <button
        type="button"
        onClick={onPrev}
        aria-label="Previous month"
        className="flex h-8 w-8 items-center justify-center rounded border border-slate-300 hover:bg-slate-100"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={onLabelClick ?? (() => undefined)}
        className="min-w-[88px] rounded border border-slate-300 px-3 py-1 text-sm font-medium hover:bg-slate-100"
      >
        {label}
      </button>
      <button
        type="button"
        onClick={onNext}
        aria-label="Next month"
        className="flex h-8 w-8 items-center justify-center rounded border border-slate-300 hover:bg-slate-100"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
